import { Component, Input, OnInit } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { GalleryGroup } from 'src/app/Models/gallarygroupmaster';
import { ApiService } from 'src/app/Service/api.service';


@Component({
  selector: 'app-gallarygroupmaster',
  templateUrl: './gallarygroupmaster.component.html',
  styleUrls: ['./gallarygroupmaster.component.css']
})
export class GallarygroupmasterComponent implements OnInit {

  @Input() drawerClose: Function;
  @Input() data: GalleryGroup;
    isSpinning = false
  logtext:string = "";



  constructor(private api: ApiService, private message: NzNotificationService) {
  }

  ngOnInit() {
  
  }
  


  close(): void {
    this.drawerClose();

	this.logtext = 'CLOSED - GalleryGroup form';
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

  }

  save(addNew: boolean): void {
    var isOk = true
    if (this.data.NAME == undefined || this.data.NAME=="") {
      this.message.error("Please Enter Name" , "");
      isOk = false
    }

 if (this.data.SEQUENCE_NO == undefined || this.data.SEQUENCE_NO==0) {
      this.message.error("Please Enter Sequence No" , "");
      isOk = false
    }
    
    if(isOk)
    {
    this.isSpinning = true;
  
      if (this.data.ID) {

	

        this.api.updateGalleryGroup(this.data)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
              this.message.success("GalleryGroup information updated Successfully...", "");

	this.logtext = 'Update & Close - GalleryGroup form - SUCCESS '+ JSON.stringify(this.data)+" KEYWORD [U - GalleryGroup ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

              if (!addNew)
                this.drawerClose();
              this.isSpinning = false;
            }
            else {

	this.logtext = 'Update & Close - GalleryGroup form - ERROR - '+ JSON.stringify(this.data)+" KEYWORD [U - GalleryGroup ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

              this.message.error("Failed to update galleryGroup information...", "");
              this.isSpinning = false;
            }
          });
      }
      else {

        this.api.createGalleryGroup(this.data)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
              this.message.success("GalleryGroup information added successfully...", "");

              if (!addNew)
	{
                this.drawerClose();

	this.logtext = 'Save & Close - GalleryGroup form - SUCCESS - '+ JSON.stringify(this.data)+" KEYWORD [C - GalleryGroup ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });
	}

              else {
                this.data = new GalleryGroup();
	this.logtext = 'Save & New - GalleryGroup form - SUCCESS - '+ JSON.stringify(this.data)+" KEYWORD [C - GalleryGroup ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

              }
              this.isSpinning = false;
            }
            else {
              this.message.error("Failed to add galleryGroup information...", "");
	this.isSpinning = false;
	this.logtext = 'Save & Close - GalleryGroup form - ERROR - '+ JSON.stringify(this.data)+" KEYWORD [C - GalleryGroup ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });
              
            }
          });
      }
  }
}


}
